import { shortMonthAndYear } from "@similarweb/pro-logic-components";
import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { useTranslation } from "pro-features/components/WithTranslation";
import DurationService, { BasicDurations } from "app/services/DurationService";

export const MarketConsolidationComparisonWidget = () => {
    const t = useTranslation();

    const subtitleDate = DurationService.getDurationData(BasicDurations.LAST_MONTH).forAPI.to;
    const subtitleFilters = [
        {
            filter: "date",
            value: {
                to: subtitleDate,
                format: shortMonthAndYear,
            },
        },
    ];

    return (
        <WidgetContainer
            withBorder
            height="430px"
            bodyHeight="340px"
            subtitleFilters={subtitleFilters}
            title={t("market.analysis.industry.overview.market.distribution.title")}
            tooltip={t("market.analysis.industry.overview.market.distribution.tooltip")}
            automationId="industry-analysis-overview-comparison-market-distribution"
        >
            <Flex
                justifyContent="center"
                alignItems="center"
                height="100%"
            >
                <EmptyState
                    title={t("industryoverview.market.difficulty.comparison.empty.title")}
                    subtitle={t("industryoverview.market.difficulty.comparison.empty.subtitle")}
                />
            </Flex>
        </WidgetContainer>
    );
};
